<script setup lang="ts">
import { onBeforeUnmount, watchEffect } from "vue";
import { Facade } from "@/drawing";
import { isCanvasDrawing } from "@/stores/CanvasViewState";
import ToolsMenu from "../Tools/ToolsMenu.vue";
import { Z_INDEX_TOOLBAR } from "./constants";
import {
  canvasTopForIcons,
  isToolbarOverflowing,
  TOOLBAR_EDGE_GAP,
  toolbarBottom,
  toolbarSideStartPx,
  toolbarWidth,
} from "@/stores/CanvasLayoutState";

// La barre flotte sur le bord gauche du plan : la poignée de la règle
// horizontale se pose à sa droite, au même bord que le dock replié de l'outil
// texte qui la recouvre (pixels du canvas = pixels écran).
watchEffect(() => {
  if (!Facade.isInitialized) return;
  Facade.rulers.setHorizontalHandleOffset(toolbarSideStartPx.value);
});

onBeforeUnmount(() => {
  if (Facade.isInitialized) Facade.rulers.setHorizontalHandleOffset(0);
});
</script>

<template>
  <!--
  Couloir de la barre : toute la hauteur du plan, entre l'en-tête et la règle
  horizontale. La barre y flotte, centrée et collée au bord gauche (comme la
  barre de sélection au bord bas) ; elle se cale en haut si même deux
  colonnes ne tiennent pas.
  -->
  <div
    v-if="toolbarWidth > 0"
    class="toolbar-lane position-absolute no-capture canvas-icon-scaled"
    :class="{ overflowing: isToolbarOverflowing }"
    :style="{
      top: `${canvasTopForIcons + TOOLBAR_EDGE_GAP}px`,
      bottom: `${toolbarBottom}px`,
      left: 0,
      zIndex: Z_INDEX_TOOLBAR,
    }"
  >
    <!-- Transparente pendant un tracé, comme les autres barres flottantes :
         on dessine à travers (panneaux d'options compris). -->
    <nav
      class="canvas-toolbar capture"
      :class="{ 'drawing-active': isCanvasDrawing }"
      data-canvas-toolbar
      :aria-label="$t('canvas:toolbar.label')"
      :style="{ width: `${toolbarWidth}px` }"
    >
      <ToolsMenu />
    </nav>
  </div>
</template>

<style lang="scss" scoped>
.toolbar-lane {
  display: flex;
  align-items: center;

  &.overflowing {
    align-items: flex-start;
  }
}

// Dimensions reprises par utils/toolbar-layout (padding, bordures).
.canvas-toolbar {
  padding: 8px 0;
  border: 1px solid var(--canvas-border);
  border-left: none;
  border-radius: 0 14px 14px 0;
  background-color: var(--canvas-bg);
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.5);
}
</style>
